<div class="section-container flex flex-column gap-3" *ngIf="hasSuggestionItems(suggestionItems$ | async)">
	<span class="font-bold">{{ translations['NeedAnythingElse'] }}?</span>
	<div class="flex flex-row gap-2">
		<div
			*ngFor="let detail of suggestionItems$ | async"
			class="container-dialog-header relative"
			style="position: relative; margin: 0; height: 200px"
            [class.out-of-stock-container]="isSuggestedItemOutOfStock(detail)"
		>
			<div class="rounded image-container">
				<img [src]="productChannel(detail, 'imagen') || no_image" alt="Item Image" class="image-item" />

				<div class="add-btn pointer" (click)="onAddSuggestionItem(detail)">
					<app-icon iconName="plus" color="white" size="14"></app-icon>
				</div>

				<div *ngIf="isSuggestedItemOutOfStock(detail)" class="w-full flex justify-content-center mt-1">
					<div class="out-of-stock-item">
						<div class="out-of-stock-label">
							{{ translations['outOfStock'] }}
						</div>
					</div>
				</div>

				<div class="flex justify-content-start mt-1">
					<span class="suggestion-text">{{ productChannel(detail, 'nombre') }}</span>
				</div>
				<div class="flex justify-content-start mt-1">
					<span class="suggestion-text font-bold">
						{{ productChannelPrice(detail, 'precio') | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
					</span>
				</div>
			</div>
		</div>
	</div>
</div>